import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-4 relative overflow-hidden" data-id="element-100">
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-blue-900/10 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-101"></div>

      <div className="max-w-5xl mx-auto" data-id="element-102">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-103">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-104">
            <div className="inline-flex items-center justify-center p-3 bg-blue-500/10 rounded-full mb-6" data-id="element-105">
              <Activity className="w-8 h-8 text-blue-500" data-id="element-106" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-107">
              EL MECANISMO ÚNICO:
              <br data-id="element-108" />
              <span className="text-blue-500" data-id="element-109">ACTIVACIÓN DE NITRÓGENO</span>
            </h2>

            <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-110">
              <p data-id="element-111">
                El <strong data-id="element-112">Protocolo 7 Minutos</strong> utiliza la biomecánica
                para despertar el endotelio.
              </p>
              <p data-id="element-113">
                Mediante una secuencia específica de ejercicios de presión y
                respiración diafragmática, forzamos la liberación masiva de
                Óxido Nítrico localizado.
              </p>
              <div className="p-5 bg-slate-900 border-l-4 border-blue-500 rounded-r-xl" data-id="element-114">
                <p className="font-medium text-slate-200" data-id="element-115">
                  Es, en esencia, abrir la llave de paso de forma manual para
                  que la sangre no tenga otra opción más que llenar las cámaras
                  de forma natural y firme.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="md:w-1/2 w-full max-w-md mx-auto" data-id="element-116">
            <div className="relative" data-id="element-117">
              <div className="absolute inset-0 bg-blue-500/20 blur-2xl rounded-full transform scale-90" data-id="element-118"></div>
              <img src="https://cdn.magicpatterns.com/uploads/4XJAxL1LqPZmUoF4ryzigx/Diseno_sin_titulo.png" alt="Protocolo 7 Minutos Book Cover" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-slate-800" data-id="element-119" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}